<script>
import TenantServicesBase from "@/components/TenantServicesBase";
export default {
  extends: TenantServicesBase,
  data: () => ({
    configType: 'Commsportal',
    apiSuffix: 'commsportal',
    tenantDataKey: 'commsportal_tenant',
    urlKey: 'commsportal_url',
    generateUrlString: '.commsportal.co.uk'

  }),
  methods: {
    getEnvType: function(type) {
      // 17 = TYPE_INSIGHT_ECS: the combined Insight ECS env is selectable as a
      // web environment (and as a worker env, where it falls back to web) just
      // like the combined EB TYPE_INSIGHT_WEB_WORKER (15).
      if (type === 'web') {
        return [9, 15, 17];
      }
      if (type === 'worker') {
        return [10, 15, 17];
      }
    },
  },
  name: "tenant-commsportal-service"
}
</script>
